import { useNavigate, useParams } from 'react-router-dom';

const useMembershipTypeSearch = () => {
  const { membershipTypeId } = useParams();
  const navigate = useNavigate();

  const membershipTypeSelected = (selectedMembershipTypeId: string) => {
    // Safely convert both to numbers for comparison
    const currentMembershipTypeId = membershipTypeId ? parseInt(membershipTypeId, 10) : undefined;
    const selectedId = parseInt(selectedMembershipTypeId, 10);

    if (currentMembershipTypeId !== undefined && selectedId === currentMembershipTypeId) {
      return;
    }
    void navigate(`/membership-types/${selectedId}`);
  };

  return {
    membershipTypeId,
    membershipTypeSelected
  };
};

export default useMembershipTypeSearch;
